
import React, { useState, useRef, useEffect } from 'react';

const MarketingChoosing = () => {
  const ChoosingData = [
    {
      heading: "Affordability",
      description: "We offer competitive pricing plans tailored to meet the budgetary constraints of businesses, startups, and individuals, ensuring accessibility and affordability for all.",
    },
    {
      heading: "Customization & Flexibility",
      description: "We work closely with clients to understand their unique needs and objectives, delivering customized digital marketing solutions that align with their brand identity, target audience, and business goals.",
    },
    {
      heading: "Quality & Expertise",
      description: "Despite offering cheap solutions, we never compromise on quality. Our team of experienced digital marketers ensures that all campaigns are well-planned, executed, and optimized for maximum results.",
    },
    {
      heading: "Measurable Results",
      description: "We provide comprehensive reporting and analysis to track the performance of digital marketing campaigns, providing clients with valuable insights into audience engagement, conversion rates, and ROI.",
    }
  ];

  return (
    <div className="col-lg-6">
      <div className="accordions-new is-first-expanded">
        {ChoosingData.map((item, index) => (
          <AccordionItem key={index} title={item.heading} content={item.description} />
        ))}
      </div>
    </div>
  );
};

const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        contentRef.current.style.maxHeight = contentRef.current.scrollHeight + 'px';
      } else {
        contentRef.current.style.maxHeight = '0px';
      }
    }
  }, [isOpen]);

  return (
    <article className="accordion">
      <div className="accordion-head" onClick={toggleAccordion}>
        <span>{title}</span>
        <span className={`icon ${isOpen ? 'open' : ''}`}>
          <i className={`fa ${isOpen ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
        </span>
      </div>
      <div
        ref={contentRef}
        className={`accordion-body ${isOpen ? 'open' : ''}`}
        style={{ maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0px' }}
      >
        <div className="content">
          <p>{content}</p>
        </div>
      </div>
    </article>
  );
};

export default MarketingChoosing;
